var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('click-tooltip',{staticClass:"overflow-text-tooltip",attrs:{"placement":"bottom-start"},scopedSlots:_vm._u([{key:"target",fn:function(){return [_vm._t("default")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"overflow-text-tooltip__popup"},[_vm._t("default")],2)]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }